import {
  Box,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import WaitingClockIcon from "../../icons/WaitingClockIcon";
import AvatarWithName from "../AvatarWithName";
import { TickCircleIcon } from "../../assets/constants";
import { dateTimeFormat } from "../../utils/helpers";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import comm_pending_icon from "../../assets/images/comm_pending_icon.png";
import comm_done_icon from "../../assets/images/comm_done_icon.png";

const CptCodesCard = ({
  item,
  activeTab,
  cptCode,
  patientName,
  imageUrl,
  bgColor,
  approved_at,
  timeSpent,
  transmissions,
  openCptIndividualViewHandler,
  below1200Screen = false,
  selectedCptCode,
  smartSortEnabled,
  communicationDone,
  openCptIndividualView,
}) => {
  const screenMedia = useMediaQuery("(max-width:1310px)");
  const isBelow1310Screen = below1200Screen ? below1200Screen : screenMedia;
  const isBelow1200Screen = useMediaQuery("(max-width:1200px)");
  const isBelow820Screen = useMediaQuery("(max-width:820px)");

  const getAgencyDetail = useSelector((state) => state.getAgencyDetail);
  const { agencyDetail } = getAgencyDetail;

  function getPercentage() {
    if (cptCode === "98980" || cptCode === "98981") {
      const percentage = timeSpent ? (timeSpent / 1200) * 100 : 0;
      return Math.round(percentage);
    } else if (cptCode === "98977") {
      const cptTransmissions = JSON.parse(transmissions || "[]")?.filter(
        (item) => item?.type === "pain_entry" || item?.type === "medicine_entry"
      );

      const currentMonth = dayjs().month();
      const currentYear = dayjs().year();

      const currentMonthTransmissions = cptTransmissions?.filter((t) => {
        const date = dayjs(t.date);
        return date.month() === currentMonth && date.year() === currentYear;
      });

      const distinctDates = [
        ...new Set(currentMonthTransmissions?.map((item) => item?.date)),
      ];

      const inProgressPerc =
        (distinctDates?.length / agencyDetail?.agency?.number_of_days_for_77) *
        100;

      return Math.round(inProgressPerc) >= 100
        ? 100
        : Math.round(inProgressPerc);
    }
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      gap="12px"
      padding="4px 8px"
      borderRadius="8px"
      onClick={() => openCptIndividualViewHandler(item)}
      sx={{
        cursor: "pointer",
        background: smartSortEnabled
          ? "linear-gradient(90deg, #FFECFE 0%, #F0F7FF 50.48%)"
          : "#FCFCFC",
      }}
      boxShadow={
        selectedCptCode?.id === item?.id ? "inset 0 0 2px  #0C80F3" : ""
      }
    >
      {activeTab === 0 ? (
        <WaitingClockIcon color="#FF852D" />
      ) : (
        <TickCircleIcon />
      )}
      {(isBelow1310Screen && !isBelow1200Screen) ||
      isBelow820Screen ||
      openCptIndividualView ? (
        <Stack flex="1" gap="2px">
          <Typography variant="body1">CPT Code {cptCode} </Typography>
          <AvatarWithName
            name={patientName}
            imageURL={imageUrl}
            size="1.4rem"
            avatarFontSize="1.4rem"
            columnGap="4px"
            avatarBgColor={bgColor}
          />
        </Stack>
      ) : (
        <>
          <Stack flex="1">
            <Typography variant="body1">CPT Code {cptCode} </Typography>
          </Stack>

          <Box flex="1">
            <AvatarWithName
              name={patientName}
              imageURL={imageUrl}
              size="1.4rem"
              avatarFontSize="1.4rem"
              columnGap="4px"
              avatarBgColor={bgColor}
            />
          </Box>
        </>
      )}

      {activeTab === 0 ? (
        <Box
          flex="1"
          display="flex"
          alignItems="center"
          gap="12px"
          justifyContent="flex-end"
        >
          {cptCode === "98980" || cptCode === "98981" ? (
            <Box width="18px" height="18px">
              {communicationDone ? (
                <img
                  width="100%"
                  height="100%"
                  src={comm_done_icon}
                  alt="communication done"
                />
              ) : (
                <img
                  width="100%"
                  height="100%"
                  src={comm_pending_icon}
                  alt="communication pending"
                />
              )}
            </Box>
          ) : (
            <></>
          )}

          <Stack direction="row" alignItems="center" gap="2px" minWidth="50px">
            <Box flex="1">
              <WaitingClockIcon />
            </Box>
            <Box>
              <Typography variant="caption" color="secondary">
                {getPercentage()}%
              </Typography>
            </Box>
          </Stack>
        </Box>
      ) : (
        <Typography variant="caption" color="secondary">
          {dateTimeFormat(approved_at)}
        </Typography>
      )}
    </Box>
  );
};

export default CptCodesCard;
